<template>
  <div class="minipaint">
    <v-card-title
      class="headline grey lighten-2"
      primary-title
    >
      <v-layout justify-space-between>
        <span>Image Editor</span>
        <span>
          <v-btn  @click="cancel()">Cancel</v-btn>
          <v-btn  class="success"  @click="my_save()">Save</v-btn>
        </span>
      </v-layout>
    </v-card-title>

    <iframe ref="myFrame" style="width:100%; height:750px;"
            id="myFrame" src="/minipaint/"></iframe>

    <ProgressDialog :progress="loadingProgress" :text="loadingText" :show="loadingShow"></ProgressDialog>
</div>

</template>

<script>
import {mapState} from 'vuex'
import ProgressDialog from './ProgressDialog'
import utils from '../../utils.ts'

export default {
  name: 'MiniPaint',
  props: ['img', 'imgChanged'],
  components: {
    ProgressDialog
  },
  data () {
    return {
      loadingText: '',
      loadingShow: 'true',
      loadingProgress: 0
    }
  },
  computed: {
    ...mapState({
    })
  },
  watch: {
    // img: function () {
    //   console.log('MiniPaint IMG Changed...')
    //   this.load()
    // }
  },
  mounted: function () {
    console.log('MiniPaint Mounted...')
    // this.load()
  },
  methods: {
    checkIframeLoaded: function () {
      const func = (resolve) => {
        var iframe = document.getElementById('myFrame')
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document

        // Check if loading is complete
        if (iframeDoc.readyState === 'complete') {
          // The loading is complete, call the function we want executed once the iframe is loaded
          resolve(true)
        } else {
          window.setTimeout(() => func(resolve), 100)
        }
      }

      const p = new Promise((resolve, reject) => {
        func(resolve)
      })
      return p
    },
    toDataURL: function (url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        var reader = new FileReader()
        reader.onloadend = function () {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    getLayers: function () {
      // Returns a Promise with the Layers once we can get them! (They load late)

      const func = (resolve) => {
        var Layers = this.$refs['myFrame'].contentWindow.Layers
        if (Layers && Layers != null) {
          resolve(Layers)
          return true
        } else {
          window.setTimeout(() => func(resolve), 100)
        }
        return false
      }

      const p = new Promise((resolve, reject) => {
        func(resolve)
      })
      return p
    },
    load: function () {
      this.loadingText = 'Loading...'
      this.loadingProgress = 10
      this.loadingShow = true

      if (!this.img || this.img == null) {
        console.error('ERROR: IMG is null in MiniPaint')
        this.loadingShow = false
        return
      }
      if (this.img.imgBlob) {
        this.checkIframeLoaded().then(() => {
          this.loadingProgress += 20
          console.log('iFrame loaded1')
          this.open_image(this.img.imgBlob)
        })
      } else {
        // We have a non-base64 image
        // this.toDataURL(this.img.downloadURL, this.open_image, 'image/jpeg')
        this.toDataURL(this.img.downloadURL, (base64) => {
          this.loadingProgress += 20
          console.log('Converted to base64 complete')
          this.checkIframeLoaded().then(() => {
            this.loadingProgress += 20
            console.log('iFrame loaded2')
            this.open_image(base64)
          })
        })
      }
    },
    /**
     * will open image on minipaint
     *
     * @param {string|image} image image or image id
     */
    open_image: function (base64img) {
      if (typeof base64img === 'string') {
        console.log('MiniPaint: IMG is a string:' + base64img.substring(0, 50))
        // image = document.getElementById(image)
      } else {
        // console.log('IMG IS: ' + JSON.stringify(image))
        var urlCreator = window.URL || window.webkitURL
        var imageUrl = urlCreator.createObjectURL(base64img) // So we can view it
        // TODO:  Make sure to delete this imageURL from memory!
        base64img = imageUrl
      }
      // var Layers = document.getElementById('myFrame').contentWindow.Layers

      var name = 'EditImage' // image.src.replace(/^.*[\\\/]/, '') // eslint-disable-line
      var image = new Image()
      image.onload = () => { // have to wait for image to load
        console.log('MiniPaint image onload complete')
        var newLayer = {
          name: name,
          type: 'image',
          data: image,
          width: image.naturalWidth || image.width,
          height: image.naturalHeight || image.height,
          width_original: image.naturalWidth || image.width,
          height_original: image.naturalHeight || image.height
        }
        console.log('new Layer: ' + JSON.stringify(newLayer))
        this.getLayers().then((Layers) => {
          Layers.reset_layers() // Clear them out!
          Layers.insert(newLayer)
          this.loadingProgress = 100
          this.loadingShow = false
        })
      }
      image.src = base64img
    },

    cancel: function () {
      this.$emit('cancel')
    },
    my_save: function () {
      this.loadingText = 'Processing...'
      this.loadingProgress = 10
      this.loadingShow = true
      // var Layers = document.getElementById('myFrame').contentWindow.Layers
      var Layers = this.$refs['myFrame'].contentWindow.Layers

      var tempCanvas = document.createElement('canvas')
      var tempCtx = tempCanvas.getContext('2d')
      var dim = Layers.get_dimensions()
      tempCanvas.width = dim.width
      tempCanvas.height = dim.height
      Layers.convert_layers_to_canvas(tempCtx)
      this.loadingProgress += 30

      // // slow way for IE, Edge -- TODO: Use the code below instead!
      // var data = tempCanvas.toDataURL()
      // this.loadingProgress += 50
      // // console.log(data)
      // this.imgChanged(data, false)

      // if (utils.is_edge_or_ie() === false) {
      //   // update image using blob (faster)
      //   tempCanvas.toBlob((blob) => {
      //     // alert('Data length: ' + blob.size)
      //     this.imgChanged(blob, true)
      //   }, 'image/gif')
      //   // }, 'image/jpeg', 0.9)
      // } else {
      //   // slow way for IE, Edge
      //   var data = tempCanvas.toDataURL()
      //   // console.log(data)
      //   this.imgChanged(data, false)
      //   // alert('Data length: ' + data.length)
      // }

      utils.addToBlobSupportIfNeeded()
      tempCanvas.toBlob((blob) => {
        // alert('Data length: ' + blob.size)
        this.imgChanged(blob, true)
      }, 'image/gif')


      tempCanvas.remove() // Remove the temp canvas
      this.loadingProgress = 100
      this.loadingShow = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
